
export enum DisputeNoteTypeCd {
	APPROVER_NOTES = 'ApproverNotes',
	GENERAL = 'General',
	NEEDS_MORE_INFO = 'NeedsMoreInfo',
	REQUESTER_NOTES = 'RequesterNotes'}

